var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyLegal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1334 2.30931C9.13549 2.33933 9.13549 2.36946 9.1334 2.39948C9.11323 2.51071 9.0578 2.6125 8.97531 2.6898C8.89282 2.7671 8.78764 2.8158 8.67533 2.82869H6.95847C6.8496 2.81429 6.74796 2.76622 6.66776 2.6912C6.58757 2.61618 6.53283 2.51797 6.51122 2.4103C6.50879 2.37788 6.50879 2.34533 6.51122 2.31291L7.20013 1.62401L7.69787 1.12626C7.73158 1.09322 7.77691 1.07471 7.82411 1.07471C7.87132 1.07471 7.91664 1.09322 7.95035 1.12626L8.4481 1.62401L9.1334 2.30931Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67535 2.82867C8.62702 2.90941 8.60089 3.00149 8.59961 3.09558V2.83228L8.67535 2.82867Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0685 3.0956C13.0745 3.16818 13.0654 3.24121 13.0418 3.31009C13.0182 3.37897 12.9805 3.4422 12.9312 3.49578C12.8818 3.54936 12.8219 3.59213 12.7553 3.62138C12.6886 3.65064 12.6165 3.66574 12.5437 3.66574C12.4709 3.66574 12.3989 3.65064 12.3322 3.62138C12.2655 3.59213 12.2056 3.54936 12.1563 3.49578C12.1069 3.4422 12.0693 3.37897 12.0456 3.31009C12.022 3.24121 12.0129 3.16818 12.0189 3.0956C12.0189 2.52932 11.2975 2.04961 10.4463 2.04961C9.98399 2.05612 9.53092 2.18025 9.12983 2.4103C9.13192 2.38028 9.13192 2.35015 9.12983 2.32013L8.44092 1.63122C9.0286 1.22603 9.72529 1.00848 10.4391 1.00723C11.8891 0.996413 13.0685 1.9378 13.0685 3.0956Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51122 2.30929C6.50861 2.3429 6.50861 2.37667 6.51122 2.41028C6.11001 2.17737 5.65502 2.05305 5.19111 2.04959C4.34711 2.04959 3.62574 2.52931 3.62574 3.09558C3.63176 3.16816 3.62266 3.24119 3.59902 3.31007C3.57538 3.37895 3.53771 3.44218 3.48839 3.49576C3.43907 3.54934 3.37918 3.59211 3.31249 3.62137C3.2458 3.65062 3.17377 3.66573 3.10094 3.66573C3.02812 3.66573 2.95608 3.65062 2.8894 3.62137C2.82271 3.59211 2.76281 3.54934 2.71349 3.49576C2.66417 3.44218 2.6265 3.37895 2.60286 3.31007C2.57922 3.24119 2.57012 3.16816 2.57614 3.09558C2.57614 1.94139 3.75198 1 5.20193 1C5.91675 1.00209 6.61434 1.21954 7.20373 1.62399L6.51122 2.30929Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03424 2.83228V3.09558C7.03296 3.00149 7.00683 2.90941 6.9585 2.82867L7.03424 2.83228Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60689 2.83228H7.0343V9.39314H8.60689V2.83228Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9694 11.8386V12.8016H4.67542V11.8422C4.67495 11.7275 4.6972 11.6137 4.74089 11.5076C4.78459 11.4015 4.84887 11.3051 4.93001 11.224C5.01116 11.1428 5.10757 11.0785 5.21369 11.0348C5.3198 10.9911 5.43352 10.9689 5.54828 10.9694H10.1001C10.3304 10.9703 10.5509 11.0622 10.7137 11.225C10.8765 11.3878 10.9684 11.6084 10.9694 11.8386V11.8386Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.183 10.1794C10.1835 10.283 10.1635 10.3856 10.1242 10.4814C10.0849 10.5772 10.0271 10.6644 9.95402 10.7377C9.88096 10.8111 9.79412 10.8694 9.69848 10.9091C9.60285 10.9489 9.50031 10.9693 9.39674 10.9693H6.24796C6.14471 10.9693 6.04246 10.949 5.94706 10.9095C5.85166 10.87 5.76498 10.812 5.69197 10.739C5.61896 10.666 5.56104 10.5793 5.52152 10.4839C5.48201 10.3885 5.46167 10.2863 5.46167 10.183C5.46167 10.0798 5.48201 9.97753 5.52152 9.88213C5.56104 9.78673 5.61896 9.70005 5.69197 9.62704C5.76498 9.55402 5.85166 9.4961 5.94706 9.45659C6.04246 9.41707 6.14471 9.39674 6.24796 9.39674H9.39674C9.49983 9.39626 9.602 9.41616 9.69737 9.45528C9.79275 9.4944 9.87946 9.55197 9.95252 9.6247C10.0256 9.69743 10.0836 9.78387 10.1231 9.87907C10.1627 9.97426 10.183 10.0763 10.183 10.1794Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5419 3.62219L14.6411 7.03067H10.4463L12.5419 3.62219Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09919 3.62219L1 7.03067H5.19837L3.09919 3.62219Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19837 7.03064C5.19837 7.58738 4.97721 8.12132 4.58354 8.51499C4.18986 8.90866 3.65593 9.12983 3.09919 9.12983C2.54245 9.12983 2.00851 8.90866 1.61484 8.51499C1.22116 8.12132 1 7.58738 1 7.03064H5.19837Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6411 7.03064C14.6411 7.58738 14.42 8.12132 14.0263 8.51499C13.6326 8.90866 13.0987 9.12983 12.5419 9.12983C11.9852 9.12983 11.4513 8.90866 11.0576 8.51499C10.6639 8.12132 10.4427 7.58738 10.4427 7.03064H14.6411Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6411 15.3372V16.5635C14.6416 16.621 14.6306 16.6779 14.6089 16.7311C14.5871 16.7843 14.555 16.8326 14.5144 16.8732C14.4737 16.9138 14.4254 16.946 14.3723 16.9677C14.3191 16.9895 14.2621 17.0004 14.2047 17H3.53923C3.48178 17.0004 3.42481 16.9895 3.37165 16.9677C3.31848 16.946 3.27018 16.9138 3.22955 16.8732C3.18893 16.8326 3.1568 16.7843 3.13504 16.7311C3.11328 16.6779 3.10232 16.621 3.1028 16.5635V15.3372C3.10232 15.2798 3.11328 15.2228 3.13504 15.1696C3.1568 15.1165 3.18893 15.0682 3.22955 15.0275C3.27018 14.9869 3.31848 14.9548 3.37165 14.933C3.42481 14.9113 3.48178 14.9003 3.53923 14.9008H14.2047C14.3204 14.9008 14.4314 14.9468 14.5133 15.0286C14.5951 15.1104 14.6411 15.2215 14.6411 15.3372V15.3372Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77461 14.9008H4.93872V16.9964H6.77461V14.9008Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5455 14.9008H10.7096V16.9964H12.5455V14.9008Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10281 12.8052V14.9008H1.69975C1.584 14.9008 1.47299 14.8548 1.39115 14.773C1.3093 14.6911 1.26332 14.5801 1.26332 14.4644V13.2308C1.26284 13.1734 1.2738 13.1164 1.29556 13.0632C1.31732 13.0101 1.34945 12.9618 1.39008 12.9211C1.4307 12.8805 1.479 12.8484 1.53217 12.8266C1.58534 12.8049 1.6423 12.7939 1.69975 12.7944L3.10281 12.8052Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87019 12.8052H4.93872V14.9008H8.87019V12.8052Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8052 13.2308V14.4572C12.8052 14.5729 12.7592 14.6839 12.6773 14.7658C12.5955 14.8476 12.4845 14.8936 12.3687 14.8936H10.7096V12.8052H12.3724C12.4859 12.8052 12.5949 12.8498 12.6759 12.9294C12.7568 13.0091 12.8033 13.1173 12.8052 13.2308V13.2308Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93867 12.8052H3.10278V14.9008H4.93867V12.8052Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7096 12.8052H8.87012V14.9008H10.7096V12.8052Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyLegal);
export default __webpack_public_path__ + "static/media/easy-legal.067c1521ddb09929a6fd0d9fd3aaf8c5.svg";
export { ForwardRef as ReactComponent };